import { render, staticRenderFns } from "./PhoneTask.vue?vue&type=template&id=0b940698&scoped=true"
import script from "./PhoneTask.vue?vue&type=script&lang=js"
export * from "./PhoneTask.vue?vue&type=script&lang=js"
import style0 from "./PhoneTask.vue?vue&type=style&index=0&id=0b940698&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b940698",
  null
  
)

export default component.exports